// Settings the client-side applies upon navigation, see applyHeadSettings(). The others are HTML-only.
export const configsClientSide = ['title', 'lang'] as const
